import { render, staticRenderFns } from "./FedExLogo.vue?vue&type=template&id=6319e85b&scoped=true&"
import script from "./FedExLogo.vue?vue&type=script&lang=js&"
export * from "./FedExLogo.vue?vue&type=script&lang=js&"
import style0 from "./FedExLogo.vue?vue&type=style&index=0&id=6319e85b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6319e85b",
  null
  
)

export default component.exports